module.exports = __webpack_public_path__ + "img/vine-snake.42ead51b.jpg";